import React, { useState, useRef } from 'react';
import IntegrationForm from './IntegrationForm';
import IntegrationsList from './IntegrationsList';
import IntegrationTypesList from './IntegrationTypesList';
import IntegrationsStats from './IntegrationsStats';
import IntegrationsStatsBar from './IntegrationsStatsBar';
import IntegrationsHeader from './IntegrationsHeader';
import CanonicalPropertiesPage from './CanonicalPropertiesPage';
import useIntegrations from './hooks/useIntegrations';
import './integrations.css';

const IntegrationsPage = () => {
  const [showForm, setShowForm] = useState(false);
  const [editingIntegration, setEditingIntegration] = useState(null);
  const [selectedIntegrationType, setSelectedIntegrationType] = useState(null);
  const integrationsListRef = useRef(null);
  const integrationTypesListRef = useRef(null);
  
  const {
    user,
    integrationTypes,
    loading,
    error,
    saveIntegration,
    clearError,
    setPageError
  } = useIntegrations();

  const handleCreateIntegration = (integrationType) => {
    setEditingIntegration(null);
    setSelectedIntegrationType(integrationType);
    setShowForm(true);
  };

  const handleEditIntegration = (integration) => {
    setEditingIntegration(integration);
    setSelectedIntegrationType(null);
    setShowForm(true);
  };

  const handleFormSubmit = async (formData) => {
    try {
      await saveIntegration(formData, editingIntegration);
      setShowForm(false);
      setEditingIntegration(null);
      setSelectedIntegrationType(null);
      integrationsListRef.current?.refresh();
      integrationTypesListRef.current?.refresh();
    } catch (err) {
      throw err;
    }
  };

  const handleFormCancel = () => {
    setShowForm(false);
    setEditingIntegration(null);
    setSelectedIntegrationType(null);
  };

  const handleComponentError = (errorMessage) => {
    setPageError(errorMessage);
  };

  if (loading || !user) {
    return (
      <div className="integrations-container">
        <div className="loading">Loading...</div>
      </div>
    );
  }

  return (
    <div className="integrations-container">
      <IntegrationsHeader user={user} />

      <div className="integrations-main">
        {error && (
          <div className="error-message">
            {error}
            <button className="close-error" onClick={clearError}>
              ×
            </button>
          </div>
        )}

        <div className="integrations-grid">
          <IntegrationsStats />

          <IntegrationsStatsBar />

          <IntegrationTypesList
            ref={integrationTypesListRef}
            onCreateIntegration={handleCreateIntegration}
          />
          
          <IntegrationsList
            ref={integrationsListRef}
            onEdit={handleEditIntegration}
            onError={handleComponentError}
          />

          {(user.role === 'admin' || user.tenant_code === 'admin') && (
            <>
              <CanonicalPropertiesPage />
            </>
          )}
        </div>
      </div>

      {/* Integration Form Modal */}
      {showForm && (
        <IntegrationForm
          integration={editingIntegration}
          integrationTypes={integrationTypes}
          selectedIntegrationType={selectedIntegrationType}
          onSubmit={handleFormSubmit}
          onCancel={handleFormCancel}
        />
      )}
    </div>
  );
};

export default IntegrationsPage;
